export default [
  {
    name: "aiMail",
    path: "/ai/mail",

    meta: { rights: ["ai_mail"], hideBottomNavigation: true, hideAppBar: true, fullWidth: true },

    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/ai/mail/aiMailView.vue"),
  },
]
